import { render } from "./RestoranKontrolna.vue?vue&type=template&id=9c3d8c5a&scoped=true"
import script from "./RestoranKontrolna.vue?vue&type=script&lang=js"
export * from "./RestoranKontrolna.vue?vue&type=script&lang=js"

import "./RestoranKontrolna.vue?vue&type=style&index=0&id=9c3d8c5a&lang=css"
import "./RestoranKontrolna.vue?vue&type=style&index=1&id=9c3d8c5a&lang=css"
import "./RestoranKontrolna.vue?vue&type=style&index=2&id=9c3d8c5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c3d8c5a"]])

export default __exports__